

import React, { useEffect, useState } from 'react';

const WordReversal = () => {
  const [word, setWord] = useState('');
  const [reversed, setReversed] = useState('');

  useEffect(() => {
    const SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition;
    const recognition = new SpeechRecognition();
    recognition.continuous = true;
    recognition.interimResults = true;
    recognition.lang = 'en-US';

    recognition.onresult = (event) => {
      let finalTranscript = '';
      for (let i = event.resultIndex; i < event.results.length; ++i) {
        if (event.results[i].isFinal) {
          finalTranscript += event.results[i][0].transcript;
        }
      }
      if (finalTranscript) {
        setWord(finalTranscript);
        setReversed(finalTranscript.split('').reverse().join(''));
      }
    };

    recognition.start();
    return () => recognition.stop();
  }, []);

  return (
    <div>
      <h2>Word Reversal</h2>
      <p>Say a word!</p>
      <p>{word}</p>
      <p>Reversed: {reversed}</p>
    </div>
  );
};

export default WordReversal;



